import { useCallback } from "react";
import { Platform } from "react-native";

import { useNavigationHook } from "../../context/Platform/hooks";

import type { GestureResponderEvent, PressableProps } from "react-native";

interface usePressableLinkArgs {
  onPress?: PressableProps["onPress"];
  target?: string;
  download?: string;
  rel?: string;
  href?: string;
  to?: string;
}

export function usePressableLink({
  onPress,
  target,
  download,
  href,
  rel,
  to,
}: usePressableLinkArgs) {
  const navigation = useNavigationHook();

  const onPressHandler = useCallback(
    (e: GestureResponderEvent) => {
      if (to) {
        const metaKey = (e as any).metaKey ?? false;
        const ctrlKey = (e as any).ctrlKey ?? false;

        if (!(target == "_blank")) {
          if (metaKey === false && ctrlKey === false) {
            e.preventDefault();
            navigation.navigate(to);
          }
        }
      }
      if (onPress) onPress(e);
    },
    [to, target, navigation, onPress]
  );

  const webProps = Platform.select({
    web: {
      href: to ?? href,
      hrefAttrs: {
        target,
        rel,
        download,
      },
    },
    default: {},
  });

  return {
    onPress: to || onPress ? onPressHandler : undefined,
    ...webProps,
  };
}
